export const navLinks = [
  { id: 'overview', label: '概览' },
  { id: 'story', label: '剧情' },
  { id: 'characters', label: '角色' },
  { id: 'episodes', label: '分集看点' },
  { id: 'themes', label: '主题解读' },
  { id: 'reviews', label: '观后感' },
  { id: 'watch', label: '观看指南' },
  { id: 'faq', label: '常见问题' },
];

export const heroStats = [
  { value: '6', label: '核心角色群像' },
  { value: '8', label: '分集看点速览' },
  { value: '4', label: '主题解读视角' },
  { value: '100%', label: '正版观看指引' },
];

export const heroTags = ['都市情感', '同学会重逢', '群像叙事', '悬念铺陈'];

export const storyFacts = [
  { label: '题材', value: '都市情感 · 群像 · 轻悬疑' },
  { label: '叙事结构', value: '同学会重逢 → 往事回闪 → 多线并行' },
  { label: '内容基调', value: '克制写实，表面平静下暗流涌动' },
  { label: '观看节奏', value: '慢热铺垫，中段渐入佳境' },
  { label: '适合人群', value: '偏爱群像剧与情感悬疑的观众' },
  { label: '内容来源', value: '剧迷公开资料整理，最终以官方为准' },
];

export const storyParagraphs = [
  '一场多年后的同学会，把一群早已各奔东西的人重新拉回同一张桌子。有人混得风生水起，有人原地打转，也有人把当年的秘密一藏就是十几年。重逢的开场总是寒暄与玩笑，可越聊越深，被时间压下去的旧账、误会与情感纠葛，会一件件浮上水面。',
  '《出轨同学会》这个题名本身就带着一层双关：它既指向一场聚会上被重新审视的关系，也指向那些在稳定生活之外偷偷生长的、说不清道不明的选择。剧集没有急着站队评判谁对谁错，而是把镜头稳稳对准每个人当下的处境。',
  '如果你正在找这部剧的完整信息、角色脉络和分集看点，这一页就是把散落各处的零碎资料重新理顺的一份观剧参考。我们不提供任何未经授权的下载或观看入口，只帮你更快看懂这部剧在讲什么，以及可以到哪里合法地看它。',
];

export const characters = [
  {
    name: '苏念',
    role: '同学会召集人',
    tag: '克制',
    desc: '这场聚会的发起者。她习惯把场面照顾得妥帖周到，也习惯把自己的心事藏到最后。越是想让所有人相安无事，越容易在某个瞬间绷不住。',
    quote: '有些话，隔了十年反而更难开口。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20film%20still%20of%20a%20calm%20thirty-something%20East%20Asian%20woman%20with%20neatly%20tied%20hair%20wearing%20a%20soft%20knit%20blouse%2C%20quiet%20thoughtful%20expression%2C%20seated%20beside%20a%20warm%20window%2C%20muted%20cream%20and%20amber%20blurred%20interior%20background%2C%20soft%20directional%20side%20light%2C%20shallow%20depth%20of%20field%2C%20subtle%20film%20grain%2C%20editorial%20moody%20photography&width=800&height=1000&seq=ds-char-01&orientation=portrait',
  },
  {
    name: '陆时衍',
    role: '当年的老同桌',
    tag: '内敛',
    desc: '话不多，却是整场聚会里最被留意的那个人。他和苏念之间那段没说完的往事，是全剧最经不起追问的一条线。',
    quote: '我不是不想解释，是解释了也没人信。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20film%20still%20of%20a%20composed%20East%20Asian%20man%20in%20his%20thirties%20wearing%20a%20dark%20knit%20sweater%2C%20faint%20guarded%20smile%2C%20relaxed%20posture%2C%20standing%20near%20a%20softly%20lit%20bookshelf%2C%20warm%20sepia%20and%20deep%20wine%20blurred%20background%2C%20gentle%20rim%20light%2C%20shallow%20depth%20of%20field%2C%20film%20grain%2C%20editorial%20moody%20photography&width=800&height=1000&seq=ds-char-02&orientation=portrait',
  },
  {
    name: '林晚',
    role: '当年的班花',
    tag: '锋利',
    desc: '看起来活得最漂亮的那一个。她擅长把生活经营成别人羡慕的样子，也最清楚这份光鲜背后付出了什么代价。',
    quote: '别用你们的标准，替我定义过得好不好。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20film%20still%20of%20an%20elegant%20East%20Asian%20woman%20in%20her%20thirties%20wearing%20a%20deep%20red%20dress%2C%20confident%20slightly%20distant%20gaze%2C%20standing%20in%20a%20dim%20warmly%20lit%20lounge%2C%20amber%20and%20burgundy%20blurred%20background%20with%20soft%20bokeh%2C%20dramatic%20side%20lighting%2C%20shallow%20depth%20of%20field%2C%20subtle%20film%20grain%2C%20editorial%20cinematic%20photography&width=800&height=1000&seq=ds-char-03&orientation=portrait',
  },
  {
    name: '程亦川',
    role: '归来者',
    tag: '体面',
    desc: '聚会上最会说话的人，也是最先被戳破的人。事业有成的外壳之下，是他一直回避去面对的那段关系。',
    quote: '成年人的体面，有时候就是一层窗户纸。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20film%20still%20of%20a%20well-groomed%20East%20Asian%20man%20in%20his%20late%20thirties%20wearing%20a%20tailored%20charcoal%20jacket%2C%20composed%20corporate%20expression%2C%20standing%20in%20a%20warm%20amber-lit%20corridor%2C%20muted%20gold%20and%20taupe%20blurred%20background%2C%20soft%20window%20light%20from%20the%20side%2C%20shallow%20depth%20of%20field%2C%20film%20grain%2C%20editorial%20cinematic%20photography&width=800&height=1000&seq=ds-char-04&orientation=portrait',
  },
  {
    name: '何知夏',
    role: '话最少的旁观者',
    tag: '清醒',
    desc: '她几乎不参与争论，却把每个人的反应都看在眼里。很多时候，正是她不经意的一句平静追问，把话题推向了最疼的地方。',
    quote: '你们都在讲道理，没人问过当事人想不想。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20film%20still%20of%20a%20quiet%20East%20Asian%20woman%20in%20her%20thirties%20wearing%20thin%20round%20glasses%20and%20a%20muted%20olive%20cardigan%2C%20observant%20calm%20expression%2C%20seated%20with%20a%20notebook%20in%20a%20warm%20dim%20room%2C%20soft%20amber%20and%20beige%20blurred%20background%2C%20gentle%20practical%20lighting%2C%20shallow%20depth%20of%20field%2C%20subtle%20film%20grain%2C%20editorial%20photography&width=800&height=1000&seq=ds-char-05&orientation=portrait',
  },
  {
    name: '江屿',
    role: '最后到的人',
    tag: '局外',
    desc: '他迟到了整整一个小时，进门时所有人的表情都变了。他的出现，把聚会原本约好的那条边界彻底打乱。',
    quote: '我本来不想来的，可有些账总得当面算。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20film%20still%20of%20a%20young%20East%20Asian%20man%20in%20his%20early%20thirties%20wearing%20a%20rain-damp%20casual%20jacket%2C%20weary%20direct%20gaze%2C%20standing%20at%20a%20doorway%20with%20warm%20interior%20light%20behind%20him%2C%20moody%20amber%20and%20deep%20brown%20blurred%20background%2C%20backlight%20rim%20and%20soft%20shadow%2C%20shallow%20depth%20of%20field%2C%20film%20grain%2C%20editorial%20cinematic%20photography&width=800&height=1000&seq=ds-char-06&orientation=portrait',
  },
];

export const episodes = [
  {
    no: '第 1 集',
    title: '重逢：一张桌子，十几种表情',
    summary:
      '开场用一场看似热闹的同学会立住了人物关系。谁坐主位、谁主动敬酒、谁全程低头看手机，几个小动作就把立场交代得清清楚楚。',
    points: ['人物入场方式各不相同，靠细节而非台词介绍身份', '聚会场合的礼仪与尴尬，是后续冲突的引线'],
  },
  {
    no: '第 2 集',
    title: '旧账：被提起的名字',
    summary:
      '话题从近况聊到当年，一个谁都以为早就翻篇的名字被重新提起，饭桌的气氛第一次明显降温。',
    points: ['关键人物通过“被谈论”而非“出场”建立悬念', '群像戏的节奏开始从寒暄转向试探'],
  },
  {
    no: '第 3 集',
    title: '回闪：那年夏天的版本不止一个',
    summary:
      '同一段往事，在不同角色的回忆里呈现出彼此矛盾的细节。观众第一次意识到，叙述者未必都诚实。',
    points: ['多视角回闪造成信息差，是剧集的核心手法之一', '细节出入本身就是线索，值得回看对照'],
  },
  {
    no: '第 4 集',
    title: '边界：关系里说不出口的部分',
    summary:
      '几条感情线在这一集同时被推近。有人试图越界，有人拼命守住距离，聚会的轻松外壳开始出现裂缝。',
    points: ['情感戏以留白和沉默为主，克制处理', '每段关系都配有对照的另一段，形成互文'],
  },
  {
    no: '第 5 集',
    title: '确认：纸终究包不住火',
    summary:
      '一个被刻意隐瞒的真相在酒后失言中露出马脚。此前所有欲言又止的镜头，到这里集中兑现。',
    points: ['铺垫的回收集中在这一集，信息量密度高', '群戏中每个人的即时反应比台词更有信息'],
  },
  {
    no: '第 6 集',
    title: '分岔：有人留下来，有人先走',
    summary:
      '冲突到达顶点后，剧集没有急着给结论，而是把重点放在每个人愿意承担多少。有人选择摊牌，也有人选择退场。',
    points: ['高潮后主动降速，给情绪留出消化空间', '退场与留守的选择，暗示了各自的价值排序'],
  },
  {
    no: '第 7 集',
    title: '对照：如果当年换个选择',
    summary:
      '贯穿全剧的一组对照关系被明确点出。假如当年走向不同，这些人的今天会不会是另一副样子。',
    points: ['以假设式叙事讨论选择与代价，不作道德裁决', '结构上与开篇的同学会形成首尾呼应'],
  },
  {
    no: '第 8 集',
    title: '收束：同学会散场之后',
    summary:
      '聚餐结束，人们各自回到自己的生活。答案并没有完全给全，但每个角色都在这短短一夜里往前挪了一步。',
    points: ['开放式结局，把判断权交还给观众', '散场后的空镜与开篇的热闹形成强烈对照'],
  },
];

export const themeTabs = [
  {
    key: 'relationship',
    label: '情感关系',
    title: '关系不是是非题，而是一道选择题',
    intro:
      '这部剧最耐看的地方，是它几乎不给任何人贴标签。出轨也好，守约也好，每个人在做出选择的那一刻，其实都有自己的理由和代价。',
    points: [
      '把“对错”换成“处境”，让角色先于道德判断成立',
      '每段关系都安排了代价，而非单向的诱惑叙事',
      '沉默与留白承担了大量情感表达，台词并不说满',
    ],
  },
  {
    key: 'ensemble',
    label: '群像叙事',
    title: '一张桌子，六种活法',
    intro:
      '同学会天然是一个群像容器。同一个时空里塞进性格、阶层和婚姻状态各异的六个人，冲突几乎是自动发生的。',
    points: [
      '用座次、称呼、敬酒顺序等社交仪式快速区分人物',
      '配角并非陪衬，每个人都有独立且完整的一条支线',
      '群戏调度讲究“同时说话也要同时沉默”，信息层次分明',
    ],
  },
  {
    key: 'suspense',
    label: '悬念铺陈',
    title: '谜底不在终点，散落在每一句家常里',
    intro:
      '它不靠强情节推着你走，而是把悬念埋进闲聊、往事和一次次欲言又止里，让你自己拼出全貌。',
    points: [
      '多视角回闪制造信息差，观众掌握的信息始终多于单个角色',
      '关键道具与重复出现的细节承担“埋伏”的功能',
      '悬念服务于人物，而非为了反转而反转',
    ],
  },
  {
    key: 'cinema',
    label: '视听语言',
    title: '暖色包裹着冷故事',
    intro:
      '整体影像刻意使用温暖的琥珀与酒红色调，与人物之间的疏离感形成反差。越是热闹的场面，光打得越柔。',
    points: [
      '低饱和暖色调统一全片气质，避免情绪外露',
      '大量浅景深与中近景，把人物推到观众眼前',
      '空镜头与留白用于转场，也用于让观众喘口气',
    ],
  },
];

export const reviewTags = ['全部', '好评', '中肯', '热议'];

export const reviews = [
  {
    name: '看完第三集又倒回去重看',
    tag: '好评',
    text: '一开始以为又是狗血的都市情感，结果被它的克制圈粉了。同一段往事三个人讲出三个版本，这种叙事太抓人。',
    rating: 5,
  },
  {
    name: '慢热但值得',
    tag: '中肯',
    text: '前两集节奏确实偏慢，差点弃剧。撑到第三集回闪出来之后完全停不下来。建议给自己两集耐心。',
    rating: 4,
  },
  {
    name: '群像才是主角',
    tag: '好评',
    text: '最喜欢的是每个人都不是工具人。连那个台词不多的旁观者，都有自己的完整弧线，这点很难得。',
    rating: 5,
  },
  {
    name: '关于结局的讨论特别多',
    tag: '热议',
    text: '开放式结局吵成两派了。有人觉得没给交代，我倒觉得这正是它的高明之处，把判断权交回观众手里。',
    rating: 4,
  },
  {
    name: '色调一眼记住',
    tag: '好评',
    text: '琥珀和酒红的光影太舒服了，明明讲的是冷的故事，画面却是暖的，这种反差感很上头。',
    rating: 5,
  },
  {
    name: '配乐可以再大胆点',
    tag: '中肯',
    text: '整体完成度很高，就是个别情绪高点配乐略显保守。如果这里敢放手一点，冲击力会更强。',
    rating: 4,
  },
];

export const watchGuides = [
  {
    icon: 'ri-play-circle-line',
    title: '正版平台观看',
    desc: '剧集在各大正版视频平台上线，搜索剧名即可进入官方播放页。请优先通过授权渠道观看，画质、字幕和更新速度都更有保障。',
  },
  {
    icon: 'ri-notification-3-line',
    title: '关注官方账号追更',
    desc: '关注出品方与平台的官方账号，能第一时间收到开播、更新与完结通知，避免被来路不明的“资源汇总”误导。',
  },
  {
    icon: 'ri-book-open-line',
    title: '剧集资料查阅',
    desc: '想看更详细的人物关系、幕后访谈与制作花絮，可以查阅平台的官方剧集页与主创团队的公开访谈。',
  },
  {
    icon: 'ri-discuss-line',
    title: '参与剧迷讨论',
    desc: '在正规社区的剧集讨论区交流观点，和同样追剧的人一起拆解细节。友好讨论，剧透记得提前标注。',
  },
];

export const faqs = [
  {
    q: '《出轨同学会》讲的是一个什么故事？',
    a: '它围绕一场多年后的同学会展开，借一次重逢把一群人各自的婚姻、感情与旧日纠葛重新摆上台面。剧集不急着评判是非，而是把镜头对准每个人当下的处境和选择。',
  },
  {
    q: '这一页提供下载或者在线观看入口吗？',
    a: '不提供。本站是一份纯内容向的观剧参考，只整理剧情脉络、角色关系和主题解读，不包含任何未经授权的下载或播放链接。想观看请前往正版视频平台搜索剧名。',
  },
  {
    q: '在哪里可以看到这部剧？',
    a: '剧集在正版视频平台上线。建议直接在平台内搜索剧名，或关注出品方官方账号获取准确的上线信息。不同地区的上线情况可能有所差异。',
  },
  {
    q: '这部剧适合什么样的观众？',
    a: '如果你是群像剧和情感悬疑的爱好者，喜欢慢热、注重人物细节、能接受开放式结局的作品，那它会很对你的胃口。偏爱快节奏强情节的观众可能需要多给两集耐心。',
  },
  {
    q: '看这部剧需要注意什么？',
    a: '剧集涉及婚姻与情感关系等现实话题，部分情节可能引起讨论。建议成年观众观看，并尊重剧中呈现的多元处境。讨论时请注意对他人的善意，涉及剧透请主动标注。',
  },
  {
    q: '页面里的角色介绍和剧情看点准确吗？',
    a: '这些内容由剧迷根据公开资料整理，用于帮助你快速建立观剧框架，具体设定、人名与情节走向请以官方播出内容为准。若发现出入，欢迎以官方渠道的信息为最终参考。',
  },
];